/** Core Libs */
import { MetaTags } from '@helpers/meta-tags.helper';
import { getProject } from '@services/project.service';
import { getMatchingRedirect } from '@services/redirect.service';
import { GetServerSideProps, GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { ReactNode } from 'react';
import Head from 'next/head';
import MainLayout from '@layouts/main-layout/main-layout';
/** Styles */
import styles from './project-layout.module.scss';
import { IProject } from '@models/project.interface';
import { Themes } from '@layouts/main-layout/themes.enum';

interface LayoutProps {
  project: any;
  children: ReactNode;
  theme?: Themes;
}

export const ProjectLayout = ({ project, children, theme }: LayoutProps) => {
  return (
    <>
      <Head>
        {MetaTags({
          title: project.project.metaTitle,
          description: project.project.metaDescription,
          imageUrl: project.project.image,
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout theme={theme}>{children}</MainLayout>
    </>
  );
};

export default ProjectLayout;

export async function getServerSidePropsFunction(context: GetServerSidePropsContext) {
  const projectName = context.resolvedUrl.match(/\/success-stories\/(.*)\/?$/)![1];
  const response = await getProject(projectName);
  if (response.data) {
    return {
      props: {
        project: response.data,
      },
    };
  }
  const url = context.resolvedUrl;
  const redirectUrl = await getMatchingRedirect(url);
  if (redirectUrl) {
    return {
      redirect: {
        destination: redirectUrl,
        statusCode: 301,
      },
    };
  } else {
    return {
      notFound: true,
    };
  }
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  return getServerSidePropsFunction(context);
};
